const BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

let csrfToken = null;
export function setCsrfToken(t) { csrfToken = t; }
export function getCsrfToken() { return csrfToken; }

async function request(path, { method = 'GET', body = null, headers = {} } = {}) {
  const opts = {
    method,
    credentials: 'include',
    headers: { Accept: 'application/json', ...headers },
  };
  const isStateChanging = !['GET', 'HEAD', 'OPTIONS'].includes(method);
  if (isStateChanging && csrfToken) {
    opts.headers['X-CSRF-Token'] = csrfToken;
  }
  if (body !== null && body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${BASE_URL}${path}`, opts);
  let payload = null;
  try { payload = await res.json(); } catch (_) {}
  if (!res.ok || !payload || payload.success === false) {
    const err = new Error(payload?.error?.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.code = payload?.error?.code;
    err.details = payload?.error?.details;
    err.payload = payload;
    throw err;
  }
  return payload.data;
}

export const apiGet = (path) => request(path);
export const apiPost = (path, body) => request(path, { method: 'POST', body });
export const apiPatch = (path, body) => request(path, { method: 'PATCH', body });
export const apiDelete = (path) => request(path, { method: 'DELETE' });
